export const REFERRAL_CREDITS_AMOUNT = 4500;
